import { render } from "./TotalGanancias.vue?vue&type=template&id=0890637e"
import script from "./TotalGanancias.vue?vue&type=script&lang=js"
export * from "./TotalGanancias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__